import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import { connect } from 'react-redux'
import { getAll, update } from '../../actions'
import { BsBell } from 'react-icons/bs'
import icons from '../../utils/menu/icons'

const Profile = props => {
  const { notifications, user } = props

  const [toggle, setToggle] = useState(false)

  useEffect(() => {
    props.getAll(`notifications/${user.id}`, 'GET_NOTIFICATIONS')
    // eslint-disable-next-line
  }, [])

  if (!notifications) {
    return <span>Logading</span>
  }

  const handleView = id => {
    props
      .update(`notifications/${id}`, 'UPDATE_NOTIFICATION', {})
      .then(() => {
        props.getAll(`notifications/${user.id}`, 'GET_NOTIFICATIONS')
      })
    setToggle(!toggle)
  }

  return (
    <Notifications point={notifications.length > 0 ? true : false}>
      <BsBell onClick={() => setToggle(!toggle)} />
      <Ul toggle={toggle}>
        <Header>
          {notifications.length > 0 ? (
            notifications.map(item => (
              <Span onClick={() => handleView(item.id)} key={item.id}>
                <Icon>{icons[item.icon]}</Icon>
                <TextContainer>
                  <Title>{item.title}</Title>
                  <Description>{item.description}</Description>
                </TextContainer>
              </Span>
            ))
          ) : (
            <Span>No hay notificaciones</Span>
          )}
        </Header>
      </Ul>
    </Notifications>
  )
}

const mapStateToProps = state => {
  return {
    notifications: state.reducerApp.notifications,
    user: state.reducerApp.user,
  }
}

const mapDispatchToProps = {
  getAll,
  update,
}

export default connect(mapStateToProps, mapDispatchToProps)(Profile)

const Notifications = styled.div`
  height: 2.5rem;
  width: 2.5rem;
  line-height: 2.2rem;
  display: flex;
  position: relative;
  margin: 5px;
  font-weight: 500;
  font-size: 1.2rem;
  user-select: none;
  -webkit-user-select: none;
  text-align: center;
  justify-content: center;
  align-items: center;
  box-shadow: 0px 2px 3px rgba(4, 4, 7, 0.1);
  border-radius: 50%;

  ${({ point }) =>
    point &&
    `&:after {content: '';position: absolute;top: 0;right: 0;width: 8px;height: 8px;border-radius: 50%;background-color: #ff0000;}`}
`

const Ul = styled.ul`
  position: absolute;
  top: 3.5rem;
  right: 0;
  left: auto;
  margin: 0;
  list-style: none;
  padding: 0;
  text-align: left;
  background-color: ${({ theme }) => theme.backgroundButton};
  border-radius: 5px;
  box-shadow: ${({ theme }) => theme.boxShadow};
  width: 350px;
  font-weight: 400;
  display: ${({ toggle }) => (toggle ? 'block' : 'none')};
`

const Header = styled.li`
  padding: 1rem;
  text-align: center;
  display: flex;
  flex-direction: column;
  line-height: 1;
  border-bottom: ${({ theme }) => theme.border};

 
`

const Span = styled.span`
  font-size: 1rem;
  margin-top: 5px;
  color: ${({ theme }) => theme.menu_category};
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 0.5rem;
  border-radius: 5px;
  &:hover { 
    background-color: ${({ theme }) => theme.hover_color};
  }
`

const Icon = styled.span`
  font-size: 1.5rem;
  margin-right: 5px;
`

const Title = styled.span`
  font-size: 1rem;
  font-weight: 500;
`

const Description = styled.span`
  font-size: 0.8rem;
  color: ${({ theme }) => theme.menu_category};
`

const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
`
